import Schema from './schema'
import itemSchema from './item.schema'

const manpackOrderSchema = new Schema({
  order: [
    {
      employeeId: String,
      addressId: { type: String, required: false },
      data: itemSchema
    }
  ]
})

export default manpackOrderSchema
